import Axios from "axios";
import {
    SET_BUDGET_HEAD_LIST,
    UNSET_BUDGET_HEAD_LIST,
} from "@/store/mutation-types";
import { 
    budgetHeadResource,
} from "@/store/api";

const state = {
    getBudgetHeadList: [],
};

const getters = {
    getBudgetHeadList(state) {
        return state.getBudgetHeadList;
    },
};

const mutations = {
    [SET_BUDGET_HEAD_LIST](state, data) {
        state.getBudgetHeadList = data;
    },
    [UNSET_BUDGET_HEAD_LIST](state) {
        state.getBudgetHeadList = [];
    },
};

const actions = {
    saveBudgetHead({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(budgetHeadResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateBudgetHead({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${budgetHeadResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getBudgetHeadList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(budgetHeadResource)
            .then(function (response) {
            commit('SET_BUDGET_HEAD_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_BUDGET_HEAD_LIST');
            reject(error);
            });
        });
    },

    getBudgetHeadById({ commit }, data) {
        const getBudgetHeadRecordById = `${budgetHeadResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getBudgetHeadRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

